import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_table_configuration_card = _resolveComponent("table-configuration-card")!
  const _component_import_configuration_versions_modal = _resolveComponent("import-configuration-versions-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, { class: "d-flex" }, {
      default: _withCtx(() => [
        _createElementVNode("span", {
          class: "body-1 cursor-pointer",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openVersionModal && $setup.openVersionModal(...args)))
        }, _toDisplayString(_ctx.$t('currentVersion') + ': ' + $setup.gainImportConfiguration.version), 1),
        (!$setup.hideAddButton)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "ml-auto",
              type: "primary",
              disabled: !$setup.userCanWriteEngagementGainImportConfiguration || $setup.isSignedOff,
              onClick: $setup.addEntry
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('add')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          class: _normalizeClass($setup.hideAddButton ? 'ml-auto' : 'ml-2'),
          type: "primary",
          disabled: !$setup.userCanWriteEngagementGainImportConfiguration || $setup.isSignedOff,
          onClick: $setup.saveTableConfigurations
        }, {
          default: _withCtx(() => [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('save')), 1)
          ]),
          _: 1
        }, 8, ["class", "disabled", "onClick"]),
        _createVNode(_component_el_select, {
          modelValue: $setup.localSelectedProcessType,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.localSelectedProcessType) = $event)),
          class: "ml-2",
          size: "small",
          style: {"width":"180px"},
          onChange: $setup.updateLocalVars
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.processTypeOptions, (option) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: option.value,
                label: _ctx.$t(option.labelKey),
                value: option.value
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.gainTableConfigurations, (item, index) => {
      return (_openBlock(), _createBlock(_component_el_row, {
        key: index,
        class: "mt-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_table_configuration_card, {
            configuration: item,
            "disable-delete": 
        !$setup.userCanWriteEngagementGainImportConfiguration || $setup.isSignedOff
      ,
            "file-configurations": $setup.gainFileConfigurations,
            onUpdate: (configuration) => $setup.updateEntry(index, configuration),
            onDelete: ($event: any) => ($setup.deleteEntry(index))
          }, null, 8, ["configuration", "disable-delete", "file-configurations", "onUpdate", "onDelete"])
        ]),
        _: 2
      }, 1024))
    }), 128)),
    _createVNode(_component_import_configuration_versions_modal, {
      modelValue: $setup.showVersionModal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.showVersionModal) = $event)),
      "configuration-versions": $setup.gainImportConfigurationHistory,
      "disable-restore": 
      !$setup.userCanWriteEngagementGainImportConfiguration || $setup.isSignedOff
    ,
      onRestore: $setup.handleRestore,
      onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.showVersionModal = false))
    }, null, 8, ["modelValue", "configuration-versions", "disable-restore", "onRestore"])
  ], 64))
}